// extracted by mini-css-extract-plugin
export default {"loading":"PageLoading_loading__cRcOx"};